import { Component, Input, OnInit } from '@angular/core';
import { getTime } from 'src/app/shared/utils/utils';
import IPRTreadData = ZoningAPI.IPRTreadData;

@Component({
    standalone: false,
    selector: 'tr[app-pr-thread-row]',
    templateUrl: './pr-thread-row.component.html',
    styleUrls: ['./pr-thread-row.component.scss']
})
export class PrThreadRowComponent implements OnInit {
    @Input()
    prThreadData: IPRTreadData;

    @Input()
    index: number;

    createStr: string;
    duration: string;
    timer: ReturnType<typeof setInterval>;

    constructor() {}

    ngOnInit() {
        this.createStr = new Date(this.prThreadData.created).toDateString();
        this.duration = getTime((Date.now() - this.prThreadData.created) / 1000);

        this.timer = setInterval(() => {
            this.duration = getTime((Date.now() - this.prThreadData.created) / 1000);
        }, 1000);
    }

    ngOnDestroy() {
        clearInterval(this.timer);
    }
}
